import { useEffect, useState } from "react";
import axios from "axios";
import { Linkedin, Facebook, Twitter, AtSign, Instagram, Globe } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;

const NETWORKS = [
  { id: "linkedin", label: "LinkedIn", Icon: Linkedin },
  { id: "facebook", label: "Facebook", Icon: Facebook },
  { id: "twitter", label: "Twitter / X", Icon: Twitter },
  { id: "threads", label: "Threads", Icon: AtSign },
  { id: "instagram", label: "Instagram", Icon: Instagram },
  { id: "google_business", label: "Google Business Profile", Icon: Globe },
];

export const SOCIAL_NETWORKS = NETWORKS;

// Footer social icon row — renders only the profiles configured in the
// Admin "Social Links" table; hidden entirely when none are set.
export default function SocialIcons() {
  const [links, setLinks] = useState(null);
  useEffect(() => {
    axios
      .get(`${API}/api/site/social`)
      .then(({ data }) => setLinks(data?.links || {}))
      .catch(() => setLinks({}));
  }, []);
  const active = NETWORKS.filter((n) => links?.[n.id]);
  if (!active.length) return null;
  return (
    <div className="mt-6 flex items-center gap-3" data-testid="footer-social-links">
      {active.map(({ id, label, Icon }) => (
        <a
          key={id}
          href={links[id]}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={label}
          title={label}
          data-testid={`footer-social-${id}`}
          className="h-9 w-9 rounded-full border border-white/15 hover:border-emerald-400/60 flex items-center justify-center text-slate-400 hover:text-emerald-300 transition-colors"
        >
          <Icon className="w-4 h-4" />
        </a>
      ))}
    </div>
  );
}
